import { Menu as e } from "../../../menu/index.js";
import { Icon as t } from "../../../icon/index.js";
import { selectCtx as n, selectEvents as r } from "../core/models/selectors/index.js";
import { useDatePickerStore as i } from "../core/models/use-date-picker-store.js";
import { ModeEnum as a } from "../core/models/model.js";
import { UiContext as o } from "./ui-provider.js";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import l from "dayjs";
// src/design/forms/datepicker/ui/week-preset-menu.tsx
var u = [
	{
		value: "last-week",
		label: "Last week",
		offsetWeeks: -1
	},
	{
		value: "this-week",
		label: "This week",
		offsetWeeks: 0
	},
	{
		value: "next-week",
		label: "Next week",
		offsetWeeks: 1
	}
], d = () => {
	let { mode: d, isDisabled: f } = i(n), { selectWeek: p } = i(r);
	return d === a.WEEK ? /* @__PURE__ */ s(o.Consumer, { children: ({ close: n }) => /* @__PURE__ */ c(e.Root, {
		onSelect: (e) => {
			let t = u.find((t) => t.value === e.value);
			if (!t) return;
			let r = l().add(t.offsetWeeks, "week").format("YYYY-MM-DD");
			p(r), n();
		},
		children: [/* @__PURE__ */ s(e.Trigger, {
			variant: "ghost",
			size: "icon",
			disabled: f,
			"aria-label": "week-presets",
			className: "shrink-0 w-8 h-8 flex items-center justify-center",
			children: /* @__PURE__ */ s(t, {
				name: "CalendarRange",
				strokeWidth: 2,
				className: "w-4 h-4 text-muted-foreground"
			})
		}), /* @__PURE__ */ s(e.Content, { children: u.map((t) => /* @__PURE__ */ s(e.Item, {
			value: t.value,
			children: t.label
		}, t.value)) })]
	}) }) : null;
};
export { d as WeekPresetMenu };

//# sourceMappingURL=week-preset-menu.js.map